import * as React from "react";
import { cn } from "../../utils";

type ControlButtonProps = {
  icon: React.ReactNode;
  title: string;
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  danger?: boolean;
};

export const ControlButton = ({
  icon,
  onClick,
  disabled,
  active,
  danger,
  title,
}: ControlButtonProps) => (
  <button
    type="button"
    aria-label={title}
    data-safe-nav="true"
    title={title}
    onClick={() => {
      if (disabled) return;
      onClick();
    }}
    disabled={disabled}
    className={cn(
      "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded border text-gray-700 transition",
      active
        ? "border-blue-600 bg-blue-600 text-white shadow-sm"
        : danger
          ? "border-transparent text-red-600 hover:border-red-200 hover:bg-red-50"
          : "border-transparent hover:border-gray-300 hover:bg-white hover:text-blue-700",
      disabled &&
        "cursor-not-allowed border-transparent bg-transparent text-gray-300 hover:border-transparent hover:bg-transparent hover:text-gray-300",
    )}
  >
    {icon}
  </button>
);

export function ToolbarGroup({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className="flex items-center gap-1 border-r border-gray-300/80 pr-3 last:border-r-0"
      aria-label={title}
      title={title}
    >
      {children}
    </div>
  );
}
